import { render, staticRenderFns } from "./app-user.vue?vue&type=template&id=06e0b2fc&"
import script from "./app-user.vue?vue&type=script&lang=ts&"
export * from "./app-user.vue?vue&type=script&lang=ts&"
import style0 from "./app-user.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports